import { reactive } from 'vue'

const toasts = reactive([])
let nextId = 0

export function useToast() {
  function add(type, message, duration = 3000) {
    const id = ++nextId
    toasts.push({ id, type, message })
    setTimeout(() => remove(id), duration)
  }

  function remove(id) {
    const idx = toasts.findIndex(t => t.id === id)
    if (idx !== -1) toasts.splice(idx, 1)
  }

  return {
    toasts,
    success: (msg) => add('success', msg),
    error:   (msg) => add('error',   msg, 6000),
    warning: (msg) => add('warning', msg),
    remove,
  }
}
